import { ethers, BigNumber, BigNumberish } from 'ethers';

export const addDecimals = (num: BigNumberish, decimals: number): BigNumber => {
  return ethers.utils.parseUnits(num.toString(), decimals);
};
